define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll'],
    function ($, transit, modernizr, container, preloader, router, scroll) {

        var module = (function () {

            var name = 'module-brand-solution-video-content-featured';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {

            }

            /* view */

            view.publicVars = {};

            view.privateVars = {
                categoryActive: 1,
                categoryAnim: 0
            };

            view.startup = function () {
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleBrandSolutionVideoContentFeaturedHeaderMenuId, 'animate__faster animate__fadeIn', 'brand-solution-video-content-featured', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleBrandSolutionVideoContentFeaturedAnimMainId, 'animate__faster animate__slideInLeft', 'brand-solution-video-content-featured', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleBrandSolutionVideoContentFeaturedAnimBox, 'animate__faster animate__slideInRight', 'brand-solution-video-content-featured', {});
            };

            view.bind = function () {
                $(view.publicVars.cssId.moduleBrandSolutionVideoContentFeaturedCategoryCls).click(function () {
                    if(!view.privateVars.categoryAnim) {
                        view.privateVars.categoryAnim = 1;
                        view.methods.handleCategoryClick(this);
                    }
                });
            };

            view.methods = {
                handleCategoryClick: (handler) => {
                    const info = container.getData($(handler)[0], 'info');
                    const id = container.getData($(handler)[0], 'id');

                    if(view.privateVars.categoryActive == id) {
                        view.privateVars.categoryAnim = 0;
                        return;
                    }

                    $(view.publicVars.cssId.moduleBrandSolutionVideoContentFeaturedCategoryCls).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    $(handler).addClass(view.publicVars.cssId.isActiveCls.substr(1));

                    const currentHeight = $(view.publicVars.cssId.moduleBrandSolutionVideoContentFeaturedCategoryContentInnerCls).outerHeight();

                    $(view.publicVars.cssId.moduleBrandSolutionVideoContentFeaturedCategoryContentInnerCls).css({ height: currentHeight + 'px'});

                    $(view.publicVars.cssId.moduleBrandSolutionVideoContentFeaturedCategoryContentInnerCls).transit({ opacity: 0 }, 300, function () {
                        $(view.publicVars.cssId.moduleBrandSolutionVideoContentFeaturedCategoryContentInnerCls).html(info);
                        $(view.publicVars.cssId.moduleBrandSolutionVideoContentFeaturedCategoryContentInnerCls).removeAttr('style');
                        const newHeight = $(view.publicVars.cssId.moduleBrandSolutionVideoContentFeaturedCategoryContentInnerCls).outerHeight();
                        $(view.publicVars.cssId.moduleBrandSolutionVideoContentFeaturedCategoryContentInnerCls).css({ opacity: 0, height: currentHeight + 'px' });
                        $(view.publicVars.cssId.moduleBrandSolutionVideoContentFeaturedCategoryContentInnerCls).html('');

                        let speed = 300;

                        if(newHeight == currentHeight) {
                            speed = 0;
                        }

                        $(view.publicVars.cssId.moduleBrandSolutionVideoContentFeaturedCategoryContentInnerCls).transit({ height: newHeight }, speed, function () {
                            $(view.publicVars.cssId.moduleBrandSolutionVideoContentFeaturedCategoryContentInnerCls).html(info);
                            $(view.publicVars.cssId.moduleBrandSolutionVideoContentFeaturedCategoryContentInnerCls).css({ scale: 0.5 });
                            $(view.publicVars.cssId.moduleBrandSolutionVideoContentFeaturedCategoryContentInnerCls).transit({scale: 1, opacity: 1}, 300, function () {
                                view.privateVars.categoryActive = id;
                                view.privateVars.categoryAnim = 0;
                                $(view.publicVars.cssId.moduleBrandSolutionVideoContentFeaturedCategoryContentInnerCls).removeAttr('style');
                            });
                        });
                    });
                }
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();

        return module;


    });
